module.exports = __webpack_public_path__ + "img/social-icon-twitter-white.0f3ca6cd.svg";